<template>
  <div
    id="providers"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              id="ref"
              v-resize.quiet="onResize"
              class="wrap justify-space-around form-body"
            >
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.name"
                  :rules="[rules.required]"
                  label="Título"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.description"
                  :rules="[rules.required]"
                  label="Descripcion"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-select
                  v-model="form.service"
                  :items="serviceTypes"
                  :rules="[rules.required]"
                  label="Tipo de Paquetes"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.quantity"
                  :rules="[rules.required]"
                  label="Cantidad"
                  type="number"
                  append-outer-icon="mdi-plus"
                  prepend-icon="mdi-minus"
                  required
                  @click:append-outer="increment('cantidad')"
                  @click:prepend="decrement('cantidad')"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.time"
                  :rules="[rules.required]"
                  label="Tiempo (Meses)"
                  maxlength="20"
                  type="number"
                  append-outer-icon="mdi-plus"
                  prepend-icon="mdi-minus"
                  required
                  @click:append-outer="increment('tiempo')"
                  @click:prepend="decrement('tiempo')"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.comments"
                  label="Observaciones"
                />
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Form from 'vform';
  import FormToolbar from '~/components/Form/Toolbar';

  export default {
    metaInfo() {
      return { title: this.$t('services') };
    },
    components: {
      FormToolbar,
    },
    props: {
      id: [String, Number],
    },
    data: () => ({
      form: new Form({
        id: '',
        name: '',
        quantity: 1,
        description: '',
        time: '',
        comments: '',
        active: 1,
        busy: false,
      }),
      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
      },
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Nuevo Servicio',
      action: 'POST',
      baseURL: '/api/catalogs/services',
      message: 'Se ha creado el servicio exitosamente.',
      serviceTypes: ['NOMINA'],
    }),
    computed: {
      ref() { return this.form.id; },
    },

    mounted() {
      if (this.id) {
        window.axios.get(`${this.baseURL}/${this.id}`)
        .then((result) => {
          this.title = `Editar Servicio ${result.data.name}`;
          this.action = 'PUT';
          this.baseURL = `${this.baseURL}/${this.id}`;
          this.message = `Se ha actualizado el servicio ${result.data.name} exitosamente.`;
          Object.assign(this.form, result.data);
        });
      }
    },
    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.form.busy = true;
          this.store();
        }
      },
      increment(field) {
        this.form[field] = parseInt(this.form[field], 10) + 1;
      },
      decrement(field) {
        if (this.form[field] - 1 <= 0) return;
        this.form[field] = parseInt(this.form[field], 10) - 1;
      },
      store() {
        window.axios({
          url: this.baseURL,
          method: this.action,
          data: this.form,
        })
        .then(() => {
          this.$router.push({ name: 'services', params: { action: 'created', message: this.message } });
        }).catch(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      reset() {
        this.$refs.form.reset();
      },
      onResize() {
        this.emitValue('resize', {
          on: 'resize',
          id: this.ref,
          params: {
            x: window.innerWidth,
            y: window.innerHeight },
            data: this.storeStateData,
            schema: this.storeStateSchema,
        });
      },
    },
  };

</script>
